const FORM_LINK =
  "https://docs.google.com/forms/d/e/1FAIpQLSdmxeJw_kXNhdbLRU4bUwFy1P4lrb_Z2-lkSN5ppynZPXOayw/viewform";

export default FORM_LINK;
